import React from "react";
import Modal from "react-bootstrap/Modal";
import { Component } from "react";
import $ from "jquery";

class CreateNewDomain extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.item.domain_name !== this.props.item.domain_name) {
      this.domainNameError();
    }
  }

  domainNameError = () => {
    const { item, isDomainNameChanged } = this.props;

    if (item.domain_name !== "" && isDomainNameChanged === true) {
      console.log("jsx-hasValue");
      $("#domain-name-messages").show();

      if (!this.props.isDomainNameValid) {
        console.log("jsx-notvalid");
        setTimeout(() => {
          $("#successMessage").hide();
          $("#failMessage").show();
        }, 700);
      } else {
        setTimeout(() => {
          $("#successMessage").show();
          $("#failMessage").hide();
        }, 700);
      }
    } else {
      $("#domain-name-messages").hide();
    }
  };

  render() {
    console.log("CreateNewDomain.this.props", this.props);
    const isModalOpen = this.props.isCreateNewModelOpen;
    const { item,pageTittle, domainMessage } = this.props;
    let display = {
      display: display,
    };
    let DomainSuggestions = this.props.domainSuggestion.map((item, index) => {
      if (this.props.item.domain_name !== item) {
        return (
          <div
            id="domainSuggestion"
            onClick={(e) => this.props.domainSuggestionSelect(item)}
            key={item+"_"+index}
            className="point"
            style={{ color: "green" }}
          >
            <i className="fas fa-check mr-2"></i>
            <span className="text-success">{item}</span>
          </div>
        );
      }
    });
    const buttonList = [
      {
        attributes: {
          id: "closeAddNewDomainName",
          className: "btn btn-border btn-default",
          "data-dismiss": "modal",
        },
        clickHandler: this.props.toggleModel,
        name: "cancel",
      },
      {
        attributes: {
          className: "btn primary_bg",
        },
        clickHandler: {},
        name: "add",
      },
    ];
    let inputAttr = {
      id: "domainNameInput",
      type: "text",
      name: "searchText",
      className: "form-control form-control-sm",
      placeholder: "Enter the Domain",
      autoComplete: "off",
      onChange: this.props.valueChangeHandler,
      value: item !== null || item !== undefined ? item.domain_name : "",
    };
    if (item !== undefined && item !== null && item.is_active === true) {
      inputAttr = { ...inputAttr, readonly: "" };
    }

    return (
      <>
        <Modal size="md" buttonlist={buttonList} show={isModalOpen}>
          <Modal.Header>
            <h6 className="mb-0"> {pageTittle} </h6>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12 col-md-12">
                <div id="div.domainNameInput" className="input-group">
                  <input
                    {...inputAttr}
                    // type="text"
                    // name="searchText"
                    // className="form-control form-control-sm"
                    // placeholder="Enter the Domain"
                    // autoComplete="off"
                    // readonly={(item!==undefined && item!==null && item.is_active===true)?'true':''}
                    // onChange={this.props.valueChangeHandler}
                    // value={(item!==null || item!==undefined)?item.domain_name:""}
                    // style={{ height: 50 }}
                  />

                  <div className="input-group-append ">
                    {/* <a className="btn primary_bg d-flex align-items-center">
                            {" "}
                            Check the Availabilty{" "}
                            </a> */}
                    <button
                      type="button"
                      onClick={(e) =>
                        this.props.checkAvailable(item.domain_name)
                      }
                      disabled={
                        item !== undefined &&
                        item !== null &&
                        item.is_active === true
                          ? true
                          : false
                      }
                      className="btn primary_bg"
                    >
                      Check Availability
                    </button>
                  </div>
                </div>
                <div>
                  {domainMessage.succMessage !== undefined &&
                  domainMessage.succMessage !== "" ? (
                    <>
                      <span className="text-success">
                        <i className="fas fa-check-circle mr-2"></i>
                        {domainMessage.succMessage}
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                  {domainMessage.failMessage !== undefined &&
                  domainMessage.failMessage !== "" ? (
                    <>
                      <span className="text-danger">
                        <i className="fas fa-ban  mr-2"></i>
                        {domainMessage.failMessage}
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                </div>

                <div id="domain-name-messages" className="my-2">
                  {item.domain_name !== undefined && item.domain_name !== "" ? (
                    <div
                      id="failMessage"
                      style={{ display: "none", color: "red" }}
                    >
                      <i className="fas fa-ban mr-2"></i>
                      <span className="text-danager">{item.domain_name}</span>
                      <span></span>
                    </div>
                  ) : (
                    ""
                  )}
                  <div
                    id="successMessage"
                    style={{ display: "none", color: "green" }}
                  >
                    <i className="fas fa-check-circle mr-2"></i>
                    <span className="text-success">{item.domain_name}</span>
                    <div className="spinner-border"></div>
                    <span></span>
                  </div>
                </div>
                {/* {item.domain_name !== undefined && item.domain_name !== ""
                  ? DomainSuggestions
                  : null} */}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer bsPrefix="modal-footer justify-content-between">
            <button
              type="button"
              className="btn btn-border btn-default"
              onClick={this.props.toggleModel}
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn primary_bg"
              onClick={this.props.saveHandler}
              disabled={!this.props.isDomainNameValid}
            >
              Add
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default CreateNewDomain;
